import { DisplayObjectChooserType } from '../../../../@types/object-chooser-types'
import { FlowInformation } from '../../../../@types/flow-types'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { isWebView } from '../../../../utils/navigation'
import { useGoBackCallback } from './useGoBackCallback'
import { PageHead } from 'is24-corecss'
import React from 'react'
import { isEditEntryMode } from '../../../../@types/types'

export function PageHeader(props: {
  displayObjectChooser: DisplayObjectChooserType
  flowInformation: FlowInformation
}) {
  const { t } = useTranslation()
  const { displayObjectChooser, flowInformation } = props
  const { transaction, category } = flowInformation.metaData
  const { objectChooserShown } = useAppSelector((state: InitState) => state.flowFeature.objectChooserInformation)
  const entryMode = useAppSelector(
    (state: InitState) => state.insertionFeature.insertionIdentification.metaInformation?.entryMode
  )
  const goBack = useGoBackCallback(flowInformation)
  const isNativeView = isWebView()
  if (isNativeView) {
    return null
  }

  // When used in MobileView, we assume there won't be a browser refresh. Hence, the redux state of objectChooserShown won't be lost.
  const isBackBtnDisplayed = (isNativeView && objectChooserShown) || !isNativeView

  const customPageHeader = flowInformation.options?.customPageHeader
  const isWaitingListFlow = flowInformation.options?.isWaitingListFlow
  const title =
    DisplayObjectChooserType.YES === displayObjectChooser
      ? t(`header.title.objectChooser`)
      : isEditEntryMode(entryMode)
        ? t(`header.title.edit`)
        : customPageHeader?.titleKey
          ? t(customPageHeader.titleKey)
          : t(`header.title.insertion`)

  const storyLine: string =
    DisplayObjectChooserType.YES === displayObjectChooser
      ? t('header.subLine.objectChooserNew')
      : t(`header.subLine.${transaction}.${category}`, '')

  return (
    <div className={isWaitingListFlow ? 'waiting-list-centered-header' : ''}>
      <PageHead
        id='insertion-page-header'
        title={title}
        subtitle={storyLine}
        buttonText={isBackBtnDisplayed ? t('backButton') : undefined}
        onButtonClick={goBack}
        className='padding-vertical-xl'
      />
    </div>
  )
}
